export default __webpack_public_path__ + "static/media/inline3.bc941095.png";